import * as yup from 'yup';
import { minZeroMsg, requiredMsg } from '../../utils/validationMessages';
import { transactionCurrencyIdField } from '../../../../../../../schemas/transactions/TransactionsCommon.schema';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import {
  conversionRatioField,
  integerField,
  usdField,
} from '../../../../../../../schemas/common-schema-defs';

export function noteConversionFields() {
  return {
    fundId: yup.number().nullable().required(requiredMsg('Fund')),
    transactionDate: transactionDateSchema(),
    convertedSharesNo: integerField()
      .required(requiredMsg('Number of Converted Shares'))
      .min(0, minZeroMsg('Number of Converted Shares'))
      .label('Number of Converted Shares'),
    convertedPrincipalAmount: usdField()
      .required(requiredMsg('Converted Principal'))
      .min(0, minZeroMsg('Converted Principal')),
    convertedInterestAmount: usdField()
      .required(requiredMsg('Converted Interest'))
      .min(0, 'Converted Interest must be at least 0'),
    currencyid: transactionCurrencyIdField(),
    fullyDilutedShares: integerField().nullable().optional(),
    notes: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
    security: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
    conversionRatio: conversionRatioField(),
  };
}

export function noteConversionFormSchema() {
  return yup.object().shape(noteConversionFields());
}

export function noteConversionGridSchema() {
  return yup.object().shape(noteConversionFields()).omit(['fullyDilutedShares']);
}
